module.exports = __webpack_public_path__ + "static/media/vwg.f7db6a42.png";